// React
import { createElement, Fragment, useEffect, useRef } from 'react'
import { createRoot } from 'react-dom/client'
// Algolia
import '@algolia/autocomplete-theme-classic'
import { autocomplete } from '@algolia/autocomplete-js'

export function Autocomplete(props) {
  const containerRef = useRef(null)
  const panelRootRef = useRef<any>(null)
  const rootRef = useRef<any>(null)

  useEffect(() => {
    if (!containerRef.current) {
      return undefined
    }

    const search = autocomplete({
      container: containerRef.current,
      renderer: { createElement, Fragment, render: () => {} },
      render({ children }, root) {
        if (!panelRootRef.current || rootRef.current !== root) {
          rootRef.current = root

          panelRootRef.current?.unmount()
          panelRootRef.current = createRoot(root)
        }

        panelRootRef.current.render(children)
      },
      ...props
    })

    return () => {
      search.destroy()
    }
  }, [props])

  return <div className='ms-autocomplete' ref={containerRef} />
}
